export default __webpack_public_path__ + "static/media/1824.1463dced.png";